
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { Card, Dimmer, Header, Icon, Loader, Segment, Table } from 'semantic-ui-react';
import { getInActiveSubscriptions, getFailedPayments, updateExistingPlanPayment, getActiveSubscriptions } from '../../services/subscription';
import './InActiveSubscriptionContainer.less'
import Config from 'Config'
import { Elements, ElementsConsumer } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { getPaymentMethods } from '../../services/Seller';
import next from '../../assets/images/newui/sellersignup/next-btn.svg'
import PaymentClearModal from '../../components/PaymentClearModal/PaymentClearModal';
import { bindActionCreators } from 'redux';
import { setInActiveSubscriptionCount, setActiveSubscriptionCount } from '../../store/actions/seller';
import { connect } from 'react-redux';
import { sellerContext } from '../../services/User';
import { setAuthState } from '../../store/actions/actions';


const InActiveSubscriptionContainer = ({ setAuthState, setInActiveSubscriptionCount, setActiveSubscriptionCount }) => {
    const [inActiveSubs, setInActiveSubs] = useState();
    const [loading, setLoading] = useState(false);
    const [stripe, setStripe] = useState();
    const [isModalOpen, setModalState] = useState(false);
    const [card, setCard] = useState();
    const [error, setError] = useState('');
    const [failedPayments, setFailedPayments] = useState([]);
    const [paymentMethods, setPaymentMethods] = useState([]);
    const [selectedPaymentMethod, setSelectedPaymentMethod] = useState({});
    const [isCardFormVisible, setCardFormVisibility] = useState(true);
    const [selectedSubscription, setSelectedSubscription] = useState({});

    useEffect(() => {
        showLoader();
        getInActiveSubscriptions().then(res => {
            if (res.resStatus == 200) {
                setInActiveSubs(res.data);
            }
        }).finally(() => {
            hideLoader();
        })
        getPaymentMethods().then(res => {
            if (res.data) {
                setPaymentMethods(res.data)
                setSelectedPaymentMethod(res.data[0])
                setCardFormVisibility(false)
            }
            else {
                setPaymentMethods([])
            }
        })
        loadStripe(Config.stripe.key).then(res => setStripe(res));
    }, [])

    const showLoader = () => {
        window.scrollTo({
            top: 0,
            behavior: 'auto'
        });
        document.body.style.overflowY = 'hidden'
        setLoading(true);
    }

    const hideLoader = () => {
        document.body.style.overflowY = 'unset'
        setLoading(false);
    }

    const clearPayments = async (e, subscription) => {
        e.preventDefault();
        const incompletePayments = await getFailedPayments(subscription.sellerSubID);
        await processSecurePayments(incompletePayments.data.filter(fp => fp.paymentStatus == 'Action Required'))
        const failedPayments = incompletePayments.data.filter(fp => fp.paymentStatus == 'Failed');
        if (failedPayments.length) {
            setModalState(true);
            setFailedPayments(failedPayments);
            setSelectedSubscription(subscription);
        }

    }

    const processSecurePayments = async (payments) => {
        for await (const payment of payments) {
            try {
                const paymentConfirmation = await stripe.confirmCardPayment(payment.paymentIntent.client_secret, {
                    payment_method: payment.stripePaymentMethodID
                });
                if (!paymentConfirmation.error) {
                    await updateExistingPlanPayment({
                        paymentIntentID: paymentConfirmation.paymentIntent.id,
                        spPaymentID: payment.spPaymentID
                    });
                }
            } catch (err) {
                console.log(err)
            }
        }
        await resetState();
    }

    const processFailedPayments = async () => {
        let paymentMethod = selectedPaymentMethod;
        if (isCardFormVisible) {
            if (!card) {
                setError('Invalid card details.')
                return;
            }
            // payment method creation
            const paymentMethodRes = await stripe.createPaymentMethod({
                type: 'card',
                card
            });
            if (paymentMethodRes.error) {
                setError(paymentMethodRes.error.message)
                return;
            }
            paymentMethod = paymentMethodRes.paymentMethod;
        }
        let paymentError;
        for await (const failedPayment of failedPayments) {
            try {
                showLoader();
                const paymentConfirmation = await stripe.confirmCardPayment(failedPayment.paymentIntent.client_secret, {
                    payment_method: paymentMethod.id,
                    setup_future_usage: 'off_session'
                });

                if (paymentConfirmation.error) {
                    paymentError = paymentConfirmation.error.message;
                    break;
                } else {
                    await updateExistingPlanPayment({
                        paymentIntentID: paymentConfirmation.paymentIntent.id,
                        spPaymentID: failedPayment.spPaymentID
                    });
                }
            } catch (err) {
                console.log(err);
                paymentError = err;
                break;
            } finally {
                hideLoader();
            }
        }
        if (!paymentError) {
            await resetState();
            const response = await sellerContext();
            if (response && response.data) {
                setAuthState(true, response.data.user, '');
            }
        }
        else {
            setError(paymentError)
        }
    }

    const onCardFormToggle = (e, value) => {
        e.preventDefault();
        setCardFormVisibility(value);
        setError('');
    }

    const resetState = async () => {
        const { data: inActiveSubsdata } = await getInActiveSubscriptions();
        const { data: activeSubsData } = await getActiveSubscriptions();
        setInActiveSubs(inActiveSubsdata);
        setModalState(false);
        setFailedPayments([]);
        setSelectedSubscription({})
        setInActiveSubscriptionCount(inActiveSubsdata.length);
        setActiveSubscriptionCount(activeSubsData.length);
    }

    return <div className='in-active-subs-container'>
        {stripe ? <Elements stripe={stripe}>
            <ElementsConsumer>
                {({ stripe, elements }) => (
                    <>
                        {loading ? <Dimmer className='in-active-subs-loader-dimmer' active>
                            <Loader indeterminate size='massive' />
                        </Dimmer> : ''}
                        <Segment.Group>
                            <Segment size="massive" className="no-radius">
                                <Header as="h1">
                                    <Header.Content>
                                        <Icon name='bell' size='small' />
                        In Active Subscriptions
                    </Header.Content>
                                </Header>
                            </Segment>
                        </Segment.Group>
                        {inActiveSubs ? inActiveSubs.length ? window.innerWidth > 767 ? <Table celled>
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell>Category</Table.HeaderCell>
                                    <Table.HeaderCell>Plan</Table.HeaderCell>
                                    <Table.HeaderCell>Failed Payment Count</Table.HeaderCell>
                                    <Table.HeaderCell>Total Failed Amount</Table.HeaderCell>
                                    <Table.HeaderCell></Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>

                            <Table.Body>
                                {inActiveSubs.sort((a, b) => moment(b.lastPaymentDate) - moment(a.lastPaymentDate)).map(subs => <Table.Row>
                                    <Table.Cell>{subs.categoryName}</Table.Cell>
                                    <Table.Cell>{subs.planName}</Table.Cell>
                                    <Table.Cell>{subs.failedPaymentCount}</Table.Cell>
                                    <Table.Cell>$ {subs.totalAmount}</Table.Cell>
                                    <Table.Cell><button className='in-active-subs-submit' onClick={(e) => clearPayments(e, subs)}>Clear Payments <img src={next} /></button></Table.Cell>
                                </Table.Row>)}
                            </Table.Body>
                        </Table> : <div className='in-active-subs-card'>
                            {inActiveSubs.sort((a, b) => moment(b.lastPaymentDate) - moment(a.lastPaymentDate)).map(subs => <Card fluid>
                                <Card.Content>
                                    <Card.Header>{subs.categoryName}</Card.Header>
                                    <Card.Meta>{subs.planName}</Card.Meta>
                                    <Card.Description>
                                        <b>Failed Payment Count:</b> {subs.failedPaymentCount}
                                    </Card.Description>
                                    <Card.Description>
                                        <b>Total Failed Amount:</b> ${subs.totalAmount}
                                    </Card.Description>
                                </Card.Content>
                                <Card.Content>
                                    <Card.Description>
                                        <button className='in-active-subs-submit' onClick={(e) => clearPayments(e, subs)}>Clear Payments <img src={next} /></button>
                                    </Card.Description>
                                </Card.Content>
                            </Card>)}
                        </div> : <div className='in-active-subs-msg'>No In-active Subscription found!</div> : ''}
                        <PaymentClearModal
                            open={isModalOpen}
                            onClose={() => { setModalState(false); setError(''); }}
                            processFailedPayments={processFailedPayments}
                            stripe={stripe}
                            elements={elements}
                            onCardFormToggle={onCardFormToggle}
                            paymentMethods={paymentMethods}
                            setSelectedPaymentMethod={setSelectedPaymentMethod}
                            error={error}
                            isCardFormVisible={isCardFormVisible}
                            selectedPaymentMethod={selectedPaymentMethod}
                            selectedSubscription={selectedSubscription}
                            setCard={setCard}
                        />
                    </>
                )}
            </ElementsConsumer>
        </Elements> : ''}
    </div>
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        setInActiveSubscriptionCount,
        setActiveSubscriptionCount,
        setAuthState
    }, dispatch);
}

export default connect(null, mapDispatchToProps)(InActiveSubscriptionContainer);